import { styled } from '@mui/material';

import video from './section-wrap.webm';

const StyledVideo = styled('video')({
  width: '100%',
  objectFit: 'contain',
});

export const IncorrectFlowStructureImage = () => {
  return (
    <StyledVideo autoPlay loop>
      <track default />
      <source src={video} />
    </StyledVideo>
  );
};
